import React from "react";
import { motion, useTransform } from "framer-motion";

const SeoLetter = ({ letter, index, totalLetters, scrollYProgress }) => {
  // Reverse scroll progress: 1 → 0 when scrolling up
  const reverseProgress = useTransform(scrollYProgress, v => 1 - v);

  // Stagger letters left-to-right
  const delayStart = 0.2;
  const activeScrollRange = 0.1;

  const start = delayStart + (index / totalLetters) * activeScrollRange;
  const end = start + activeScrollRange / totalLetters;

  // Now opacity increases only when scrolling UP
  const opacity = useTransform(
    reverseProgress,
    [start, end],
    [0.3, 1],
    { clamp: true }
  );

  return (
    <motion.span style={{ opacity }} className="seo-letter">
      {letter === " " ? "\u00A0" : letter}
    </motion.span>
  );
};

export default SeoLetter;
